import showToaster from '../../../helpers/toasterMessages/showToaster';
import { updateSettingsData } from '../../../lib/graphql';

export default function updateSpecificSiteSettings(fieldName, value) {

	return async (dispatch, getState, { client }) => {
		try {
			
			const { data } = await client.mutate({
				mutation: updateSettingsData,
				variables: {
					fieldName,
					value
				}
			})

			if (data && data.updateSpecificSiteSettings && data.updateSpecificSiteSettings.status == 200) {
				showToaster({ messageId: 'settingUpdateSuccess', toasterType: 'success' });
			}
			else {
				showToaster({ messageId: 'commonError', toasterType: 'error' });
			}

		}
		catch (err) {
			console.log(err)
			showToaster({ messageId: 'catchError', toasterType: 'error', requestContent: err })
		}
	}
}